import React from "react";
import { connect } from "react-redux";
import { RoutesInvoker } from './../../routesInvoker';
import { push, replace } from "react-router-redux";

import "./static.scss";

interface Props {
}

export class StaticIndex extends React.Component<Props, {}> {
  render() {
    return (
      <div className="static-index">
        {this.props.children}
      </div>
    )
  }
}

